class Entity {
    constructor(type, data) {
        this.type = type;
        Object.assign(this, data);
    }

    getTitle() {
        let title = '';
        this.type.titleAttributes.forEach(a =>  {
            if (title) {
                title += ' ';
            }
            title += this[a];
        });
        return title;
    }

    getType() {
        return this.type;
    }

    getTypeName() {
        return this.type.name;
    }

    getId() {
        return this.id;
    }

    getValue(attributeId) {
        return this[attributeId];
    }

    setValue(attributeId, value) {
        this[attributeId] = value;
    }

    toJson() {
        return this.type.toJson(this);
    }
}

export default Entity;